import { render } from "./datiCalcoloModal.vue?vue&type=template&id=81ccd9ac&ts=true"
import script from "./datiCalcoloModal.vue?vue&type=script&lang=ts"
export * from "./datiCalcoloModal.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__